/** Reads a dot-separated path from a value. Empty path returns the value as-is. */
export function resolveValuePath(value: unknown, path?: string): unknown {
  if (!path || value == null) return value;
  return path.split('.').reduce<unknown>((acc, key) => {
    if (acc != null && typeof acc === 'object') {
      return (acc as Record<string, unknown>)[key];
    }
    return undefined;
  }, value);
}
